import type { ReactElement } from 'react';

export function SuccessPanel(): ReactElement {
  return (
    <img
      src="/assets/images/plus-websites/rocket-globe.png"
      alt=""
      className="vtwo:max-w-[280px] vtwo:w-full"
    />
  );
}
